import Joi from 'joi';

export interface IWordData {
  startTime: number;
  endTime: number;
  word: string;
  confidence: number;
}

const wordDataSchema = Joi.object({
  startTime: Joi.number().required(),
  endTime: Joi.number().required(),
  word: Joi.string().required(),
  confidence: Joi.number().required(),
});

export const recognitionResultSchema = Joi.object({
  text: Joi.string().required(),
  confidence: Joi.number().required(),
  isFinal: Joi.boolean().required(),
  words: Joi.array().items(wordDataSchema),
  timestamp: Joi.number().optional(),
});

export interface IRecognitionResult {
  text: string;
  confidence: number;
  isFinal: boolean;
  words?: IWordData[];
  timestamp?: number;
}
